import { Directive } from 'vue'

export const elemWidth: Directive = (el, binding) => {
  if (binding.value) {
    el.style.width = binding.value
  }
}
